import { useRoutes } from '../../routes';

export const defaultPath = useRoutes.EPK_LIST_PATH;
